export const trackPendoEvent = (eventName: string, metadata?: pendo.Metadata): void => {
  if (window.pendo) {
    window.pendo.track(eventName, metadata);
  }
};
